<template>
  <SectionWrapper :title="title" :loading="getOngoingLoansLoading">
    <template v-slot:title-action>
      <v-btn
        small
        depressed
        color="accent"
        :to="{ name: 'woori-crowd' }"
        class="rounded-3 font-weight-bold mt-n1"
        :disabled="getOngoingLoansLoading"
      >
        한도 조회 & 서류 제출
      </v-btn>
    </template>

    <section class="accent-text-box">
      <p>상품 소개</p>
      <p class="mb-0 accent--text font-size--14 font-weight-black">
        중소벤처기업부, 소상공인시장진흥공단 주도
      </p>
      <h4>이자와 수수료 전액을 정부에서 지원하는<br />소상공인 신용대출</h4>
    </section>
  </SectionWrapper>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {
    SectionWrapper: () => import('@/components/main/SectionWrapper.vue'),
  },
  computed: {
    ...mapGetters('loan', ['getOngoingLoansLoading']),
    title() {
      return `${new Date().getFullYear()} 우리동네 크라우드펀딩`
    },
  },
}
</script>

<style lang="scss" scoped></style>
